import { createTheme } from '@mui/material'
import { type TenantPaletteConfig } from '../../types'
import { paletteLight } from './light/palette-light'
import { paletteDark } from './dark/palette-dark'

const lightPalette = createTheme({
  palette: paletteLight,
}).palette

const darkPalette = createTheme({
  palette: paletteDark,
}).palette

export const pplPalette: TenantPaletteConfig = {
  light: lightPalette,
  dark: darkPalette,
}
